import childStore from '../../../../../../src/store'

let load = ({dispatch, commit, getters, state}) => {
  let queue = [
    {type: 'action', name: 'users/loadAll'},
    {type: 'action', name: 'users/loadCurrent'},
    {type: 'action', name: 'user_preferences/load'}
  ].concat(childStore.onLoad())

  // Create an empty promise for chaining
  let actions = []

  queue.forEach((task) => {
    if (task.type === 'action') {
      // Push all actions into the promise buffer
      actions.push(dispatch(task.name, task.params || undefined, {root: true}))
    } else {
      // Run the commit immediately
      commit(task.name, task.params || undefined, {root: true})
    }
  })

  return Promise.all(actions).then(() => {
    commit('setLoaded', true)
  })
}

const state = {
  loaded: false
}

const getters = {
  isLoaded: state => state.loaded
}

const actions = {
  load (context, options) {
    return load(context, options)
  },
  reload (context, options) {
    return load(context, {
      loadCurrentUser: true,
      ...options
    })
  },
  forget (context) {
    context.commit('setLoaded', false)
    localStorage.clear()
  }
}

const mutations = {
  setLoaded (state, loaded) {
    state.loaded = loaded
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/modules/app/session.js